export const GET_EAV_ATTRIBUTE_START = 'GET_EAV_ATTRIBUTE_START';
export const GET_EAV_ATTRIBUTE_SUCCESS = 'GET_EAV_ATTRIBUTE_SUCCESS';
export const GET_EAV_ATTRIBUTE_FAILED = 'GET_EAV_ATTRIBUTE_FAILED';

export const ADD_EAV_ATTRIBUTE_START = 'ADD_EAV_ATTRIBUTE_START';
export const ADD_EAV_ATTRIBUTE_SUCCESS = 'ADD_EAV_ATTRIBUTE_SUCCESS';
export const ADD_EAV_ATTRIBUTE_FAILED = 'ADD_EAV_ATTRIBUTE_FAILED';

export const UPDATE_EAV_ATTRIBUTE_START = 'UPDATE_EAV_ATTRIBUTE_START';
export const UPDATE_EAV_ATTRIBUTE_SUCCESS = 'UPDATE_EAV_ATTRIBUTE_SUCCESS';
export const UPDATE_EAV_ATTRIBUTE_FAILED = 'UPDATE_EAV_ATTRIBUTE_FAILED';

export const DELETE_EAV_ATTRIBUTE_START = 'DELETE_EAV_ATTRIBUTE_START';
export const DELETE_EAV_ATTRIBUTE_SUCCESS = 'DELETE_EAV_ATTRIBUTE_SUCCESS';
export const DELETE_EAV_ATTRIBUTE_FAILED = 'DELETE_EAV_ATTRIBUTE_FAILED';

export const GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_START = 'GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_START';
export const GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_SUCCESS = 'GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_SUCCESS';
export const GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_FAILED = 'GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_FAILED';


export const getEavAttributeStart = () => ({
  type: GET_EAV_ATTRIBUTE_START,
});

export const getEavAttributeSuccess = (data) => ({
  type: GET_EAV_ATTRIBUTE_SUCCESS,
  data
});

export const getEavAttributeFailed = (error) => ({
  type: GET_EAV_ATTRIBUTE_FAILED,
  error
});

export const addEavAttributeStart = () => ({
  type: ADD_EAV_ATTRIBUTE_START,
});

export const addEavAttributeSuccess = (data) => ({
  type: ADD_EAV_ATTRIBUTE_SUCCESS,
  data
});

export const addEavAttributeFailed = (error) => ({
  type: ADD_EAV_ATTRIBUTE_FAILED,
  error
});

export const updateEavAttributeStart = () => ({
  type: UPDATE_EAV_ATTRIBUTE_START,
});

export const updateEavAttributeSuccess = (data) => ({
  type: UPDATE_EAV_ATTRIBUTE_SUCCESS,
  data
});

export const updateEavAttributeFailed = (error) => ({
  type: UPDATE_EAV_ATTRIBUTE_FAILED,
  error
});

export const deleteEavAttributeStart = () => ({
  type: DELETE_EAV_ATTRIBUTE_START,
});

export const deleteEavAttributeSuccess = (id) => ({
  type: DELETE_EAV_ATTRIBUTE_SUCCESS,
  id
});

export const deleteEavAttributeFailed = (error) => ({
  type: DELETE_EAV_ATTRIBUTE_FAILED,
  error
});

export const getQuoteCustomersCountByMarketingSegmentStart = () => ({
  type: GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_START,
});

export const getQuoteCustomersCountByMarketingSegmentSuccess = (data) => ({
  type: GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_SUCCESS,
  data
});

export const getQuoteCustomersCountByMarketingSegmentFailed = (error) => ({
  type: GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_FAILED,
  error
});
